import { TransactionState, type ITransaction } from "@domain/Carbucks";
import { Transaction } from "@domain/Carbucks/Transaction";
import type { ITransactionViewModel, ITransactionViewModelDto } from "../Types/ITransactionViewModel";

import { useUserSettings } from "@services/UserSettings";
import { isDemo, isNotProduction } from "@modules/Utilities/Environments";
import { useMockTransactionData } from "@domain/Carbucks/_MockData";

export class TransactionsViewModel implements ITransactionViewModel
{

    transactions: ITransaction[];
    filteredTransactions: ITransaction[];
    totalPurchaseAmount: number;
    totalCashbackAmount: number;
    transactionType?: string;

    constructor( model: ITransactionViewModelDto, transactionType?: string )
    {
        const userSettings = useUserSettings();
        if( isDemo() || ( isNotProduction() && userSettings.enableDemoTransactions ) )
        {
            model.transactions = useMockTransactionData();
        }

        const states = [ TransactionState.Clear, TransactionState.Pending, TransactionState.Settled ];
        this.transactionType = transactionType;
        this.transactions = model.transactions.map( t => new Transaction( t ) );
        this.filteredTransactions = this.transactions.filter( t => states.includes( t.state ) );
        this.totalPurchaseAmount = this.filteredTransactions.reduce( ( c, t ) => c += t.purchaseAmount, 0 );
        this.totalCashbackAmount = this.filteredTransactions.reduce( ( c, t ) => c += t.cashbackAmount ?? 0, 0 );
    }

}